export default __webpack_public_path__ + "static/logo_VSE-e9d74baddeacb245593821290b9e9b78.png";